export const idx_data_axisrot = [];

idx_data_axisrot.push({
  axis_rot: '',
});

idx_data_axisrot.push({
  axis_rot: '0-30',
});

idx_data_axisrot.push({
  axis_rot: '30-60',
});

idx_data_axisrot.push({
  axis_rot: '60-90',
});
